import Vue from "vue";
/**
 * 商机的二级菜单数据
 */
export function getMenuData() {
  return [
    {
      title: "客户",
      icon: "el-icon-s-help",
      path: "1",
      flag: 1,
      children: [
        {
          title: "客户资料",
          path: "client-info",
          active: "clientInfo",
          flag: 1,
        },
        {
          title: "老板资料",
          path: "client-boss",
          active: "clientBoss",
          flag: 1,
        },
        {
          title: "客户资质",
          path: "client-qualification",
          active: "clientQualification",
          flag: 1,
        },
        {
          title: "工作交接",
          path: "client-connect",
          active: "clientConnect",
          flag: 1,
        },
        {
          title: "流失客户",
          path: "client-check",
          active: "clientCheck",
          flag: 1,
        },
        {
          title: "风控客户",
          path: "client-ready",
          active: "clientReady",
          flag: 1,
        },
      ],
    },
    {
      title: "设置",
      icon: "el-icon-s-tools",
      path: "client-setting",
      active: "clientSetting",
      flag: 1,
      children: [],
    },
  ];
}

/**
 * 获取客户信息中的抽屉数据格式
 * @param {*} title  当前客户名称
 * @param {*} authorityData  权限数据
 * @param {*} isHead  是否是机构负责人
 * @param {*} options 所有下拉框数组
 * @param {*} flag 当前打开的子页面
 *
 * options:{
 * allUser:[], // 所有用户
 * areaList:[], // 所有片区
 * sourceList:[], // 客户所有来源
 * addedValueTaxTypeList:[], // 增值税类型
 * levelList:"", // 客户等级
 * tipList:"", // 客户标签
 * }
 *
 * {
 * label:"",
 * value:""
 * }
 */
export function clientInfoDrawerData(
  title,
  authorityData,
  isHead,
  options,
  flag,
  input,
) {
  let clientInfoDrawerData = getDrawerData(title, options, flag);
  // 拼接数据显示权限
  clientInfoDrawerData =
    Vue.prototype.$initDrawerAuthorityData.initDrawerAuthorityData(
      clientInfoDrawerData,
      authorityData,
      isHead,
    );

  return clientInfoDrawerData;
}

/**
 *
 * @param {当前客户标题} title
 * @param {*} options
 * @param {*} flag
 * @param {*} input
 * @param {*} _this
 * @param {当前客户信息} clientInfo
 * @returns
 */
export function getDrawerData(
  title,
  options,
  flag,
  input,
  _this,
  clientInfo,
  subjectOfContract,
) {
  // console.log("clientInfo", clientInfo);
  // 定义一个空对象，用于存储客户信息抽屉的数据
  let clientInfoDrawerData = {
    data: {
      modelList: [],
    },
  };
  // 根据flag的值，选择不同的数据
  switch (flag) {
    case "客户信息":
      clientInfoDrawerData = {
        title: "客户设置",
        flag: false,
        CardList: [
          // {
          //   text: "客户设置",
          //   active: "info",
          //   key: "cancel",
          // },
          // {
          //   text: "联系人",
          //   active: "lianxiren",
          //   key: "cancel",
          // },
          // {
          //   text: "合同",
          //   active: "hetong",
          //   key: "cancel",
          // },
          // {
          //   text: "资质",
          //   active: "qualification",
          //   key: "showQualification",
          // },
          // {
          //   text: "档案",
          //   active: "archives",
          //   key: "archives",
          // },
          // {
          //   text: "云盘",
          //   active: "cloud",
          //   key: "cloud",
          // },
          // {
          //   text: "服务",
          //   active: "serve",
          //   key: "serve",
          // },
          // {
          //   text: "企业信息",
          //   active: "enterprise",
          //   key: "enterprise",
          // },
        ],
        cardIndex: 0,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "客户流失恢复",
            active: "recover",
            key: "recover",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
          {
            text: "流失风险标记",
            active: "prepare_loss",
            key: "prepareLoss",
          },
          {
            text: "操作记录",
            active: "operating_record",
            key: "operatingRecord",
          },
          {
            text: "角色操作日志",
            active: "role_change_log",
            // 复用"操作记录"的按钮权限key，保证与"操作记录"同时可见
            key: "operatingRecord",
          },
        ],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          gridData: [], // 关联客户数组
          isDisable: true, // 是否只读
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "客户类型",
                  key: "type",
                  type: "text",
                  value: "",
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "合约主体",
                  key: "subjectOfContract",
                  type: "select",
                  value: "",
                  options: options.SubjectContractList
                    ? options.SubjectContractList
                    : [],
                },
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "客户等级",
                  type: "select",
                  key: "clientLevel",
                  value: "",
                  options: options.levelList ? options.levelList : [],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "收费定额",
                  key: "turnover",
                  type: "select",
                  value: "",
                  options: options.turnoverList ? options.turnoverList : [],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "企业类型",
                  key: "addedValueTaxType",
                  type: "select",
                  value: "",
                  options: options.addedValueTaxTypeList
                    ? options.addedValueTaxTypeList
                    : [],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "片区",
                  type: "select",
                  key: "zone",
                  value: "",
                  options: options.areaList ? options.areaList : [],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "来源",
                  key: "source",
                  type: "selects-label",
                  value: "",
                  options: options.sourceList ? options.sourceList : [],
                },
              ],
            },
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  isSelect: false,
                  title: "客户标签",
                  key: "tip",
                  type: "tags-select",
                  tempValue: "",
                  value: [],
                  options: options.tipList ? options.tipList : [],
                },
              ],
            },
            {
              line: [
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "企业全称",
                  key: "clientName",
                  type: "input-but",
                  value: "",
                  buts: [
                    {
                      text: "工商信息",
                      active: "get_companyInfo",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "企业税号",
                  key: "enterpriseNumber",
                  type: "input",
                  value: "",
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "客户编号",
                  key: "clientNum",
                  type: "select-allow-create",
                  value: "",
                  flag: false,
                  options: options.clientNumberList
                    ? options.clientNumberList
                    : [],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "行业分类",
                  key: "industryType",
                  type: "input",
                  value: "",
                },
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "所在地区",
                  key: "area",
                  type: "area",
                  value: [],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "详细地址",
                  key: "address",
                  type: "input",
                  value: "",
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "联系电话",
                  key: "tel",
                  type: "input",
                  value: "",
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "开户行",
                  key: "bankName",
                  type: "input",
                  value: "",
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "银行账号",
                  key: "bankAccount",
                  type: "input-number2",
                  value: "",
                },
              ],
            },
            {
              line: [
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "开票客户",
                  key: "isInvoicing",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "包含社保",
                  key: "isSocialSecurity",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "包含流水",
                  key: "isStatement",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "包含园区",
                  key: "isTaxPark",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "有未开票收入",
                  key: "isUnbilledIncome",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "账本装订",
                  key: "isBookbinding",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "包含财务数据",
                  key: "isFinancialData",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
                {
                  horizontal: false,
                  isShow: true,
                  isDisable: false,
                  title: "合规客户",
                  key: "isSuitableClient",
                  type: "radio",
                  value: "N",
                  options: [
                    {
                      label: "Y",
                      text: "是",
                    },
                    {
                      label: "N",
                      text: "否",
                    },
                  ],
                },
              ],
            },
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  isSelect: false,
                  tempValue: "",
                  title: "其他服务人员",
                  key: "role",
                  type: "tags-select-obj",
                  value: [],
                  options: options.allUser ? options.allUser : [],
                },
              ],
            },
          ],
        },
      };
      break;
    case "联系人":
      let item_data = {
        line: [
          {
            horizontal: true,
            isShow: true,
            isDisable: false,
            title: "姓名",
            type: "input-buts",
            key1: "name",
            value: "新建联系人",
            buts: [
              {
                text: "删除",
                active: "shanchu",
              },
            ],
          },
          {
            horizontal: true,
            isShow: true,
            isDisable: false,
            title: "职位",
            type: "select",
            key1: "position",
            value: "老板",
            options: [
              {
                label: "老板",
                value: "老板",
              },
              {
                label: "法人",
                value: "法人",
              },
              {
                label: "股东",
                value: "股东",
              },
              {
                label: "会计",
                value: "会计",
              },
              {
                label: "其他",
                value: "其他",
              },
            ],
          },
          {
            horizontal: true,
            isShow: true,
            isDisable: false,
            title: "电话",
            key1: "phone",
            type: "input",
            value: "",
          },
          {
            horizontal: true,
            isShow: true,
            isDisable: false,
            title: "手机",
            key1: "mobile",
            type: "input",
            value: "",
          },
          {
            horizontal: true,
            isShow: true,
            isDisable: false,
            title: "邮件",
            key1: "email",
            type: "input",
            value: "",
          },
          {
            horizontal: true,
            isShow: true,
            isDisable: false,
            title: "备注",
            key1: "des",
            type: "input",
            value: "",
          },
        ],
      };
      clientInfoDrawerData = {
        title: "客户",
        flag: false,
        CardList: [
          {
            text: "客户信息",
            active: "info",
            key: "cancel",
          },
          {
            text: "联系人",
            active: "lianxiren",
            key: "cancel",
          },
          {
            text: "合同",
            active: "hetong",
            key: "cancel",
          },
          {
            text: "资质",
            active: "qualification",
            key: "showQualification",
          },
          {
            text: "档案",
            active: "archives",
            key: "archives",
          },
          {
            text: "云盘",
            active: "cloud",
            key: "cloud",
          },
          {
            text: "服务",
            active: "serve",
            key: "serve",
          },
          {
            text: "企业信息",
            active: "enterprise",
            key: "enterprise",
          },
        ],
        cardIndex: 1,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "客户流失恢复",
            active: "recover",
            key: "recover",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
          {
            text: "流失风险标记",
            active: "prepare_loss",
            key: "prepareLoss",
          },
          {
            text: "操作记录",
            active: "operating_record",
            key: "operatingRecord",
          },
        ],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          isDisable: true, // 是否只读
          butArray: [
            {
              text: "新建联系人",
              active: "newContact",
              authority: 1,
            },
          ],
          modelList: [item_data],
        },
      };
      break;
    case "合同":
      clientInfoDrawerData = {
        title: "合同查询",
        flag: false,
        subjectOfContract: subjectOfContract,
        CardList: [
          // {
          //   text: "客户设置",
          //   active: "info",
          //   key: "cancel",
          // },
          // {
          //   text: "联系人",
          //   active: "lianxiren",
          //   key: "cancel",
          // },
          // {
          //   text: "合同",
          //   active: "hetong",
          //   key: "cancel",
          // },
          // {
          //   text: "资质",
          //   active: "qualification",
          //   key: "showQualification",
          // },
          // {
          //   text: "档案",
          //   active: "archives",
          //   key: "archives",
          // },
          // {
          //   text: "云盘",
          //   active: "cloud",
          //   key: "cloud",
          // },
          // {
          //   text: "服务",
          //   active: "serve",
          //   key: "serve",
          // },
          // {
          //   text: "企业信息",
          //   active: "enterprise",
          //   key: "enterprise",
          // },
        ],
        cardIndex: 2,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "客户流失恢复",
            active: "recover",
            key: "recover",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
          {
            text: "流失风险标记",
            active: "prepare_loss",
            key: "prepareLoss",
          },
          {
            text: "操作记录",
            active: "operating_record",
            key: "operatingRecord",
          },
        ],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          isDisable: true, // 是否只读
          butArray: [
            {
              text: "发票开具",
              active: "create_invoice",
              key: "createInvoice",
            },
            {
              text: "新建合同",
              active: "create_contract",
              key: "createContract",
            },
          ],
          status: "",
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "",
                  type: "table",
                  summary: false,
                  menu: [
                    {
                      key: "contractNumber",
                      value: "合同编号",
                      type: "link",
                      width: "100",
                    },
                    {
                      key: "services",
                      value: "服务项",
                      type: "array",
                      width: "150",
                    },
                    {
                      key: "status",
                      value: "合同状态",
                      width: "100",
                      type: "text",
                    },
                    {
                      key: "money",
                      value: "合同金额",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "auditedIncome",
                      value: "已收款",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "accruedAssets",
                      value: "未收款",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "signTime",
                      value: "签订时间",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "startToEnd",
                      value: "合同期限",
                      type: "text",
                      width: "150",
                    },
                    {
                      key: "receiptCompanyAccountList",
                      value: "收款主体",
                      type: "list-text",
                      width: "150",
                    },
                  ],
                  tableData: [],
                },
              ],
            },
          ],
        },
      };
      break;
    case "资质":
      clientInfoDrawerData = {
        title: "客户",
        flag: false,
        CardList: [
          {
            text: "客户信息",
            active: "info",
            key: "cancel",
          },
          {
            text: "联系人",
            active: "lianxiren",
            key: "cancel",
          },
          {
            text: "合同",
            active: "hetong",
            key: "cancel",
          },
          {
            text: "资质",
            active: "qualification",
            key: "showQualification",
          },
          {
            text: "档案",
            active: "archives",
            key: "archives",
          },
          {
            text: "云盘",
            active: "cloud",
            key: "cloud",
          },
          {
            text: "服务",
            active: "serve",
            key: "serve",
          },
          {
            text: "企业信息",
            active: "enterprise",
            key: "enterprise",
          },
        ],
        cardIndex: 3,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
        ],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          isDisable: true, // 是否只读
          butArray: [
            {
              text: "新建资质",
              active: "create_qualification",
              key: "cancel",
              // key: "addQualification"
            },
          ],
          status: "",
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "",
                  type: "table",
                  summary: false,
                  menu: [
                    {
                      key: "number",
                      value: "资质编号",
                      type: "text",
                      width: "150",
                    },
                    {
                      key: "name",
                      value: "资质名称",
                      type: "text",
                      width: "150",
                    },
                    {
                      key: "typeName",
                      value: "资质类型",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "startServiceDate",
                      value: "开始时间",
                      width: "100",
                      type: "text",
                    },
                    {
                      key: "endServiceDate",
                      value: "到期日期",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "certificate",
                      value: "查看附件",
                      type: "file",
                      width: "100",
                    },
                    {
                      key: "certificate",
                      value: "操作",
                      type: "buts",
                      width: "180",
                      buts: [
                        {
                          name: "编辑",
                          active: "editQualification",
                          icon: "el-icon-edit",
                          key: "editQualification",
                        },
                        {
                          name: "删除",
                          active: "deleteQualification",
                          icon: "el-icon-delete",
                          key: "deleteQualification",
                        },
                      ],
                    },
                  ],
                  tableData: [],
                },
              ],
            },
          ],
        },
      };
      break;
    case "档案":
      clientInfoDrawerData = {
        title: "客户",
        flag: false,
        CardList: [
          {
            text: "客户信息",
            active: "info",
            key: "cancel",
          },
          {
            text: "联系人",
            active: "lianxiren",
            key: "cancel",
          },
          {
            text: "合同",
            active: "hetong",
            key: "cancel",
          },
          {
            text: "资质",
            active: "qualification",
            key: "showQualification",
          },
          {
            text: "档案",
            active: "archives",
            key: "archives",
          },
          {
            text: "云盘",
            active: "cloud",
            key: "cloud",
          },
          {
            text: "服务",
            active: "serve",
            key: "serve",
          },
          {
            text: "企业信息",
            active: "enterprise",
            key: "enterprise",
          },
        ],
        cardIndex: 4,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
        ],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          isDisable: true, // 是否只读
          butArray: [
            {
              text: "新增档案",
              active: "create_archives",
              key: "addArchives",
            },
          ],
          status: "",
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "",
                  type: "table",
                  summary: false,
                  menu: [
                    {
                      key: "name",
                      value: "录入物品",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "location",
                      value: "录入位置",
                      type: "text",
                      width: "110",
                    },
                    {
                      key: "createName",
                      value: "录入人",
                      width: "90",
                      type: "text",
                    },
                    {
                      key: "status",
                      value: "状态",
                      type: "text-status",
                      width: "60",
                    },
                    {
                      key: "gmtModified",
                      value: "操作时间",
                      type: "text",
                      width: "150",
                    },
                    {
                      key: "certificate",
                      value: "操作记录",
                      type: "operating",
                      width: "80",
                    },
                    {
                      key: "certificate",
                      value: "操作",
                      type: "buts-dropdown",
                      width: "65",
                      buts: [
                        { name: "领用", active: "get", key: "get" },
                        { name: "归还", active: "return", key: "return" },
                        { name: "转移", active: "move", key: "move" },
                        { name: "交付", active: "jiaofu", key: "jiaofu" },
                      ],
                    },
                  ],
                  tableData: [],
                },
              ],
            },
          ],
        },
      };
      break;
    case "云盘":
      clientInfoDrawerData = {
        title: "客户",
        flag: false,
        CardList: [
          {
            text: "客户信息",
            active: "info",
            key: "cancel",
          },
          {
            text: "联系人",
            active: "lianxiren",
            key: "cancel",
          },
          {
            text: "合同",
            active: "hetong",
            key: "cancel",
          },
          {
            text: "资质",
            active: "qualification",
            key: "showQualification",
          },
          {
            text: "档案",
            active: "archives",
            key: "archives",
          },
          {
            text: "云盘",
            active: "cloud",
            key: "cloud",
          },
          {
            text: "服务",
            active: "serve",
            key: "serve",
          },
          {
            text: "企业信息",
            active: "enterprise",
            key: "enterprise",
          },
        ],
        cardIndex: 5,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
        ],
        multipleSelection: [],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          isDisable: true, // 是否只读
          fileOrder: [],
          input: input || "", // 文件名称
          topButArray: [
            {
              text: "点击上传文件",
              active: "addFile",
              key: "addFile",
              isDisable: false,
            },
            {
              text: "新建文件夹",
              active: "addFolder",
              key: "addFile",
              isDisable: false,
            },
            {
              text: "重命名",
              active: "reNameFile",
              key: "reNameFile",
              isDisable: true,
            },
            {
              text: "移动",
              active: "moveFile",
              key: "moveFile",
              isDisable: true,
            },
            {
              text: "删除",
              active: "deleteFile",
              key: "deleteFile",
              isDisable: true,
            },
            {
              text: "下载",
              active: "downloadFile",
              key: "downloadFile",
              isDisable: true,
            },
          ],
          status: "",
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "",
                  type: "cloud",
                  menu: [
                    {
                      key: "image",
                      value: "",
                      type: "image",
                      width: "40",
                    },
                    {
                      key: "name",
                      value: "文件名",
                      type: "link",
                    },
                    {
                      key: "includeItemsNum",
                      value: "包含项",
                      type: "text",
                      width: "90",
                    },
                    {
                      key: "suitableSize",
                      value: "大小",
                      width: "90",
                      type: "text",
                    },
                    {
                      key: "renewUserName",
                      value: "更新人",
                      type: "text-status",
                      width: "90",
                    },
                    {
                      key: "gmtModified",
                      value: "更新时间",
                      type: "text",
                      width: "150",
                    },
                    {
                      authorityKey: "visibleFile",
                      key: "clientAppShow",
                      value: "客户可见",
                      type: "switch",
                      width: "80",
                    },
                  ],
                  tableData: [],
                },
              ],
            },
          ],
          upload: {
            value: {
              flag: false,
              action: _this.$fileBaseurl + "/uploadImageByMultipartFile",
              headers: {
                token: "95931b371eb64f4a9c862983ca8a5d15",
              },
              uploadParameter: {
                systemName: "finance",
                title: "客户云盘信息",
              },
            },
          },
        },
      };
      break;
    case "服务":
      clientInfoDrawerData = {
        title: "客户",
        flag: false,
        CardList: [
          {
            text: "客户信息",
            active: "info",
            key: "cancel",
          },
          {
            text: "联系人",
            active: "lianxiren",
            key: "cancel",
          },
          {
            text: "合同",
            active: "hetong",
            key: "cancel",
          },
          {
            text: "资质",
            active: "qualification",
            key: "showQualification",
          },
          {
            text: "档案",
            active: "archives",
            key: "archives",
          },
          {
            text: "云盘",
            active: "cloud",
            key: "cloud",
          },
          {
            text: "服务",
            active: "serve",
            key: "serve",
          },
          {
            text: "企业信息",
            active: "enterprise",
            key: "enterprise",
          },
        ],
        cardIndex: 6,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "客户流失恢复",
            active: "recover",
            key: "recover",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
          {
            text: "流失风险标记",
            active: "prepare_loss",
            key: "prepareLoss",
          },
          {
            text: "操作记录",
            active: "operating_record",
            key: "operatingRecord",
          },
        ],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          isDisable: true, // 是否只读
          status: "",
          butArray: [
            {
              text: "新增日程",
              active: "add_serve",
              key: "addArchives",
            },
          ],
          modelList: [
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "",
                  text: "个性需求",
                  type: "individual-needs",
                  tableData: [],
                },
              ],
            },
            {
              line: [
                {
                  horizontal: true,
                  isShow: true,
                  isDisable: false,
                  title: "",
                  type: "table",
                  summary: false,
                  menu: [
                    {
                      key: "title",
                      value: "日程事项",
                      type: "text",
                      width: "150",
                    },
                    {
                      key: "time",
                      value: "时间",
                      type: "text",
                      width: "170",
                    },
                    {
                      key: "createUserName",
                      value: "创建人",
                      type: "text",
                      width: "100",
                    },
                    {
                      key: "participants",
                      value: "参与人",
                      type: "string",
                      width: "120",
                    },
                    {
                      key: "statusName",
                      value: "状态",
                      type: "text-status",
                      width: "100",
                    },
                    {
                      key: "finishedTime",
                      value: "完成时间",
                      type: "link-transfer",
                      width: "100",
                      active: "endServe",
                      text: "点击完成",
                    },
                    {
                      key: "visitReason",
                      value: "出访记录",
                      type: "link-transfer",
                      width: "120",
                      active: "bindServe",
                      text: "点击绑定",
                    },
                    {
                      key: "certificate",
                      value: "操作",
                      type: "buts",
                      width: "100",
                      buts: [
                        {
                          name: "删除",
                          active: "deleteServe",
                          icon: "el-icon-delete",
                          key: "deleteServe",
                        },
                      ],
                    },
                  ],
                  tableData: [],
                },
              ],
            },
          ],
        },
      };
      break;
    case "企业信息":
      clientInfoDrawerData = {
        title: "客户",
        flag: false,
        CardList: [
          {
            text: "客户信息",
            active: "info",
            key: "cancel",
          },
          {
            text: "联系人",
            active: "lianxiren",
            key: "cancel",
          },
          {
            text: "合同",
            active: "hetong",
            key: "cancel",
          },
          {
            text: "资质",
            active: "qualification",
            key: "showQualification",
          },
          {
            text: "档案",
            active: "archives",
            key: "archives",
          },
          {
            text: "云盘",
            active: "cloud",
            key: "cloud",
          },
          {
            text: "服务",
            active: "serve",
            key: "serve",
          },
          {
            text: "企业信息",
            active: "enterprise",
            key: "enterprise",
          },
        ],
        cardIndex: 7,
        buttonList: [
          {
            text: "跟进",
            icon: "el-icon-edit-outline",
            active: "genjin",
            key: "followUp",
          },
        ],
        hasSetting: true,
        settingOperList: [
          {
            text: "删除客户",
            active: "delete_client",
            key: "delete",
          },
          {
            text: "申请客户流失",
            active: "run_off",
            key: "lossOf",
          },
          {
            text: "添加关联客户",
            authority: 1,
            active: "adding_associated_customer",
            key: "associat",
          },
        ],
        multipleSelection: [],
        data: {
          title: title,
          customer: 0, // 关联客户,与商机状态关联,(只有商机状态为成交才有值),其他时候为空字符串
          isDisable: true, // 是否只读
          fileOrder: [],
          input: input || "", // 文件名称
          status: "",
          modelList: [],
          clientInfo: clientInfo,
          upload: {
            value: {
              flag: false,
              action: _this.$fileBaseurl + "/uploadImageByMultipartFile",
              headers: {
                token: "95931b371eb64f4a9c862983ca8a5d15",
              },
              uploadParameter: {
                systemName: "finance",
                title: "客户云盘信息",
              },
            },
          },
        },
      };
      break;
    default:
      break;
  }
  return clientInfoDrawerData;
}
export function returnDrawerKeys(flag) {
  let keys = [];
  let drawerData = getDrawerData(
    "",
    Vue.prototype.$tagData.getDrawerOptionsList("clientInfo"),
    flag,
  ).data.modelList;
  for (let index = 0; index < drawerData.length; index++) {
    let element = drawerData[index].line;
    for (let i = 0; i < element.length; i++) {
      let ele = element[i];
      if (ele.hasOwnProperty("key")) {
        let dd = {
          name: ele.text,
          key: ele.key,
          authority: "1",
          sequence: 1,
          id: "",
        };
        keys.push(JSON.parse(JSON.stringify(dd)));
      }
    }
  }
  console.log("拿到当前抽屉的所有keys", drawerData, keys);
  return keys;
}
export function getQualificationDialogData(row, qualificationTypeList, _this) {
  return [
    {
      title: "资质编号",
      type: "input",
      value: row ? row.number : "",
    },
    {
      title: "资质名称",
      type: "input",
      value: row ? row.name : "",
      required: true,
    },
    {
      title: "资质类型",
      type: "select",
      options: qualificationTypeList,
      value: row ? row.type : "",
      required: true,
    },
    {
      title: "资质开始时间",
      type: "time_date",
      value: row ? row.startServiceDate : "",
      required: true,
    },
    {
      title: "资质到期时间",
      type: "ccc",
      value: {
        time: value.row.endServiceDate,
        noTime: value.row.endServiceDate ? false : true,
      },
      required: true,
    },
    {
      title: "到期提醒时间",
      type: "text",
      value: row ? row.number : "",
    },
    {
      title: "年审时间",
      type: "text",
      value: row ? row.annualReminder : "",
    },
    {
      title: "上传附件",
      type: "upload_file",
      value: {
        value: "", // 客户资质
        action: _this.$fileBaseurl + "/uploadImageByMultipartFile",
        headers: {
          token: "95931b371eb64f4a9c862983ca8a5d15",
        },
        uploadParameter: {
          systemName: "finance",
          title: "客户资质",
        },
      },
      flag: false,
    },
  ];
}

export function enterpriseTobList() {
  return {
    active: "企业信息",
    list: [
      {
        icon: "https://51nbimg.u51.com/3310e85afdca45248a06045736efc120.png",
        name: "企业信息",
      },
      {
        icon: "https://51nbimg.u51.com/fdbfd17f6b8d4675b682f74bcf08e144.png",
        name: "企业图谱",
      },
      {
        icon: "https://51nbimg.u51.com/141694a6b5324bc8ad28e54fd7256221.png",
        name: "经营信息",
        disabled: false,
      },
      // {
      //   icon: "https://51nbimg.u51.com/c45bab8e161440e985c83620df683aeb.png",
      //   name: "风险提示",
      //   disabled: true,
      // },
      // {
      //   icon: "https://51nbimg.u51.com/500dbf6d8a174ae9b4a9b82fbcfae4a0.png",
      //   name: "供应商/客户",
      //   disabled: true,
      // },
      // {
      //   icon: "https://51nbimg.u51.com/b44e6bb1fcac4917a60703fe40a42697.png",
      //   name: "竞品",
      // },
      // {
      //   icon: "https://51nbimg.u51.com/4ef551bad3024a02bffdb1d57e378989.png",
      //   name: "情报",
      //   disabled: true,
      // },
      // {
      //   icon: "https://51nbimg.u51.com/fce053adb6644adc95c338a26cecf2e4.png",
      //   name: "操作记录",
      // },
      {
        icon: "https://51nbimg.u51.com/b8e606bde4504ddab86c0d7e7fd4d3be.png",
        name: "联系方式",
        disabled: false,
      },
      {
        icon: "https://51nbimg.u51.com/4ef551bad3024a02bffdb1d57e378989.png",
        name: "档案",
        disabled: false,
      },
      {
        icon: "https://51nbimg.u51.com/500dbf6d8a174ae9b4a9b82fbcfae4a0.png",
        name: "云盘",
        disabled: false,
      },
      // {
      //   icon: "https://51nbimg.u51.com/b8e606bde4504ddab86c0d7e7fd4d3be.png",
      //   name: "服务",
      //   disabled: false,
      // },
    ],
  };
}

export function enterpriseComplianceList() {
  return {
    active: "证据链",
    list: [
      {
        icon: require("@/assets/img/contract.png"),
        name: "证据链",
      },
      {
        icon: require("@/assets/img/invoice.png"),
        name: "发票",
      },
      {
        icon: require("@/assets/img/budget.png"),
        name: "预算表",
      },
      {
        icon: require("@/assets/img/report.png"),
        name: "报表",
      },
      {
        icon: require("@/assets/img/service-report.png"),
        name: "服务报告",
      },
      {
        icon: "https://51nbimg.u51.com/3310e85afdca45248a06045736efc120.png",
        name: "企业信息",
      },
    ],
  };
}

// 企业信息 tab栏数据
export function enterpriseTabList(active) {
  let tabList = [];
  switch (active) {
    case "企业信息":
      tabList = {
        active: "基本信息",
        list: [
          {
            name: "基本信息",
            children: {
              active: "公司简介",
              list: [
                {
                  name: "公司简介",
                },
                {
                  name: "工商信息",
                },
                {
                  name: "股东信息",
                },
                {
                  name: "主要成员",
                },
                {
                  name: "对外投资",
                },
                {
                  name: "分支机构",
                },
                {
                  name: "工商变更",
                },
              ],
            },
          },
          {
            name: "公司发展",
            children: {
              active: "公司项目",
              list: [
                {
                  name: "融资历程",
                  disabled: true,
                },
                {
                  name: "公司项目",
                },
              ],
            },
          },
          {
            name: "企业年报",
            children: {
              active: "2011年度",
              list: [],
            },
          },
          {
            name: "资质资格",
            children: {
              active: "行政许可",
              list: [
                {
                  name: "行政许可",
                },
                {
                  name: "资质证书",
                },
                {
                  name: "建筑资质",
                },
              ],
            },
          },
          {
            name: "知识产权",
            children: {
              active: "专利信息",
              list: [
                {
                  name: "专利信息",
                },
                {
                  name: "商标信息",
                },
                {
                  name: "软件著作权",
                },
                {
                  name: "作品著作权",
                },
                {
                  name: "ICP备案",
                },
                {
                  name: "标准信息",
                },
              ],
            },
          },
          {
            name: "历史信息",
            children: {
              active: "历史工商信息",
              list: [
                {
                  name: "历史工商信息",
                },
                {
                  name: "历史股东",
                  disabled: true,
                },
                {
                  name: "历史高管",
                  disabled: true,
                },
              ],
            },
          },
        ],
      };
      break;
    case "企业图谱":
      tabList = {
        active: "企业图谱",
        list: [
          {
            name: "企业图谱",
          },
          {
            name: "股权穿透图",
          },
          {
            name: "实际控制人",
          },
          {
            name: "最终受益人",
          },
          {
            name: "关联图谱",
          },
        ],
      };
      break;
    case "经营信息":
      tabList = {
        active: "产销概况",
        list: [
          {
            name: "产销概况",
            disabled: true,
          },
          {
            name: "经营商品",
            disabled: true,
          },
          {
            name: "招投标",
          },
          {
            name: "人才信息",
            disabled: true,
          },
          {
            name: "招聘概况",
          },
          {
            name: "招聘岗位",
          },
          {
            name: "推广信息",
            disabled: true,
          },
          {
            name: "企业活跃度",
            disabled: true,
          },
          {
            name: "APP",
            disabled: true,
          },
          {
            name: "新媒体账号",
          },
          {
            name: "网站",
            disabled: true,
          },
          {
            name: "网店",
          },
          {
            name: "店铺",
            disabled: true,
          },
          {
            name: "参展信息",
            disabled: true,
          },
          {
            name: "纳税资质",
          },
          {
            name: "纳税信用",
          },
          {
            name: "进出口信用",
          },
        ],
      };
      break;
    case "风险提示":
      tabList = {
        active: "司法风险",
        list: [
          {
            name: "司法风险",
            children: {
              active: "风险信息统计",
              list: [
                {
                  name: "风险信息统计",
                },
                {
                  name: "法院公告",
                },
                {
                  name: "立案信息",
                },
                {
                  name: "开庭公告",
                },
                {
                  name: "裁判文书",
                },
                {
                  name: "被执行人",
                },
                {
                  name: "限制高消费",
                },
                {
                  name: "终本案件",
                },
                {
                  name: "失信信息",
                },
                {
                  name: "股权冻结",
                },
                {
                  name: "司法拍卖",
                },
                {
                  name: "破产重整",
                },
              ],
            },
          },
          {
            name: "经营风险",
            children: {
              active: "经营异常",
              list: [
                {
                  name: "经营异常",
                },
                {
                  name: "行政处罚",
                },
                {
                  name: "严重违法失信",
                },
                {
                  name: "环保处罚",
                },
                {
                  name: "动产抵押",
                },
                {
                  name: "股权出质",
                },
                {
                  name: "清算信息",
                },
                {
                  name: "税收违法",
                },
                {
                  name: "欠税公告",
                },
                {
                  name: "税务非正常户",
                },
                {
                  name: "简易注销",
                },
                {
                  name: "注销备案",
                },
              ],
            },
          },
          {
            name: "历史风险",
            children: {
              active: "历史经营异常",
              list: [
                {
                  name: "历史经营异常",
                },
                {
                  name: "历史行政处罚",
                },
                {
                  name: "历史严重违法失信",
                },
                {
                  name: "历史欠税公告",
                },
                {
                  name: "历史股权出质",
                },
                {
                  name: "历史动产抵押",
                },
                {
                  name: "历史裁判文书",
                },
                {
                  name: "历史裁判文书",
                },
                {
                  name: "历史被执行人",
                },
                {
                  name: "历史终本要件",
                },
                {
                  name: "历史股权冻结",
                },
              ],
            },
          },
          {
            name: "关联风险",
          },
        ],
      };
      break;
    case "供应商/客户":
      tabList = {
        active: "供应商",
        list: [
          {
            name: "国内供应商",
          },
          {
            name: "海外供应商",
          },
          {
            name: "国内客户",
          },
          {
            name: "海外客户",
          },
        ],
      };
      break;
    case "竞品":
      break;
    case "情报":
      break;
    case "操作记录":
      break;
    case "联系方式":
      tabList = {
        active: "公司联系方式",
        list: [
          {
            name: "公司联系方式",
          },
          {
            name: "关联联系方式",
          },
          {
            name: "疑似联系人",
            disabled: true,
          },
          {
            name: "人脉",
            disabled: true,
          },
          {
            name: "团队",
            disabled: true,
          },
        ],
      };
    case "档案":
      tabList = {
        active: "",
        list: [],
      };
      break;
    case "云盘":
      tabList = {
        active: "",
        list: [],
      };
    case "服务":
      tabList = {
        active: "",
        list: [],
      };
      break;
    case "证据链":
      tabList = {
        active: "客户合同",
        list: [
          {
            name: "客户合同",
          },
          {
            name: "供应商合同",
          },
        ],
      };
      break;
    case "发票":
      tabList = {
        active: "销项发票",
        list: [
          {
            name: "销项发票",
          },
          {
            name: "进项发票",
          },
        ],
      };
      break;
    case "预算表":
      tabList = {
        active: "当前",
        list: [
          {
            name: "当前",
          },
          {
            name: "历史",
          },
        ],
      };
      break;
    case "报表":
      tabList = {
        active: "",
        list: [],
      };
      break;

    default:
      break;
  }
  return tabList;
}

// 企业信息 关联公司表头数据
export function enterpriseByCompanyList() {
  return [
    {
      prop: "entname",
      label: "企业名称",
      type: "logo_link",
      width: "220px",
    },
    {
      prop: "position",
      label: "职位",
      type: "text",
      width: "190px",
    },

    {
      prop: "regcapStr",
      label: "注册资本",
      type: "text",
      width: "130px",
    },
    {
      prop: "areaList",
      label: "地区",
      type: "text",
      width: "160px",
    },
    {
      prop: "fundedRatioNumStr",
      label: "持股比例",
      type: "text",
      width: "90px",
    },
    {
      prop: "contactWayNum",
      label: "联系号码数",
      type: "text",
      width: "100px",
    },
    {
      prop: "companyStatusName",
      label: "经营状态",
      type: "companyStatusNameStr",
      width: "110px",
    },
  ];
}

// 企业经营状态
export function companyStatus(status) {
  let companyStatusNameStr = {};
  switch (status) {
    case "在营（开业）":
      companyStatusNameStr = {
        color: "#52C41A",
        bacColor: "#F6FFED",
        borderColor: "#B7EB8F",
        status,
      };
      break;
    case "注销":
    case "吊销":
      companyStatusNameStr = {
        color: "#FF4747",
        bacColor: "#fff5f5",
        borderColor: "#FFAEAE",
        status,
      };
      break;
    default:
      break;
  }
  return companyStatusNameStr;
}

export function companyInfoByTableText(active) {
  let data = [];
  switch (active) {
    case "工商信息":
      data = [
        {
          label: "法定代表人",
          value: "",
          key: "frname",
          span: 12,
          type: "text",
        },
        {
          label: "经营状态",
          value: "",
          key: "entstatusName",
          span: 12,
          type: "text",
        },
        {
          label: "企业类型",
          value: "",
          key: "enttypeName",
          span: 12,
          type: "text",
        },
        {
          label: "社会统一信用代码",
          value: "",
          key: "creditCode",
          span: 12,
          type: "text",
        },
        {
          label: "成立日期",
          value: "",
          key: "esdate",
          span: 12,
          type: "text",
        },
        {
          label: "核准日期",
          value: "",
          key: "apprdate",
          span: 12,
          type: "text",
        },
        {
          label: "经营期限",
          value: "",
          key: "opfrom",
          key1: "opto",
          span: 12,
          type: "text",
        },
        {
          label: "注册资本",
          value: "",
          key: "regcapStr",
          span: 12,
          type: "text",
        },
        {
          label: "实缴资本",
          value: "",
          key: "acconamStr",
          span: 12,
          type: "text",
        },
        {
          label: "所属地区",
          value: "",
          key: "regorgProvince",
          key1: "regorgCity",
          span: 12,
          type: "text",
        },
        {
          label: "组织机构代码",
          value: "",
          key: "orgCode",
          span: 12,
          type: "text",
        },
        {
          label: "工商注册号",
          value: "",
          key: "regno",
          span: 12,
          type: "text",
        },
        {
          label: "纳税人识别号",
          value: "",
          key: "taxpayerNum",
          span: 12,
          type: "text",
        },
        {
          label: "纳税人资质",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "参保人数",
          value: "",
          key: "ssNum",
          span: 12,
          type: "text",
        },
        {
          label: "员工规模",
          value: "",
          key: "staffNum",
          span: 12,
          type: "text",
        },
        {
          label: "曾用名",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "英文名",
          value: "",
          key: "entNameEn",
          span: 12,
          type: "text",
        },
        {
          label: "注册地址",
          value: "",
          key: "addr",
          span: 12,
          type: "text",
        },
        {
          label: "登记机关",
          value: "",
          key: "regorgName",
          span: 12,
          type: "text",
        },
        {
          label: "国标行业",
          value: "",
          key: "",
          span: 24,
          type: "text",
        },
        {
          label: "经营范围",
          value: "",
          key: "opscope",
          span: 24,
          type: "text",
        },
      ];
      break;
    case "企业基本信息":
      data = [
        {
          label: "企业名称",
          value: "",
          key: "entName",
          span: 12,
          type: "text",
        },
        {
          label: "企业经营状态",
          value: "",
          key: "busstCn",
          span: 12,
          type: "text",
        },
        {
          label: "注册号",
          value: "",
          key: "regNo",
          span: 12,
          type: "text",
        },
        {
          label: "统一社会信用代码",
          value: "",
          key: "creditCode",
          span: 12,
          type: "text",
        },
        {
          label: "企业联系电话",
          value: "",
          key: "tel",
          span: 12,
          type: "text",
        },
        {
          label: "电子邮箱",
          value: "",
          key: "email",
          span: 12,
          type: "text",
        },
        {
          label: "有限责任公司本年度是否发生股东股权转让",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "企业是否有投资信息或购买其他公司股权",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "从业人数",
          value: "",
          key: "empnum",
          span: 12,
          type: "text",
        },
        {
          label: "企业通讯地址",
          value: "",
          key: "addr",
          span: 12,
          type: "text",
        },
      ];
      break;
    case "企业资产状况信息":
      data = [
        {
          label: "资产总额",
          value: "",
          key: "assgro",
          span: 12,
          type: "text",
        },
        {
          label: "所有者权益合计",
          value: "",
          key: "totequ",
          span: 12,
          type: "text",
        },
        {
          label: "营业总收入",
          value: "",
          key: "vendinc	",
          span: 12,
          type: "text",
        },
        {
          label: "主营业务收入",
          value: "",
          key: "maibusinc",
          span: 12,
          type: "text",
        },
        {
          label: "利润总额",
          value: "",
          key: "progro",
          span: 12,
          type: "text",
        },
        {
          label: "净利润",
          value: "",
          key: "netinc",
          span: 12,
          type: "text",
        },
        {
          label: "纳税总额",
          value: "",
          key: "ratgro	",
          span: 12,
          type: "text",
        },
        {
          label: "负债总额",
          value: "",
          key: "liagro",
          span: 12,
          type: "text",
        },
      ];
      break;
    case "社保信息":
      data = [
        {
          label: "城镇职工基本养老保险",
          value: "",
          key: "so110",
          span: 12,
          type: "text",
        },
        {
          label: "职工基本医疗保险",
          value: "",
          key: "so310",
          span: 12,
          type: "text",
        },
        {
          label: "工伤保险",
          value: "",
          key: "so410",
          span: 12,
          type: "text",
        },
        {
          label: "生育保险",
          value: "",
          key: "so510",
          span: 12,
          type: "text",
        },
        {
          label: "失业保险",
          value: "",
          key: "so210",
          span: 24,
          type: "text",
        },
        {
          label: "单位缴费基数",
          value: "",
          key: "",
          span: 24,
          type: "list",
          list: [
            {
              label: "单位参加城镇职工基本养老保险缴费基数",
              value: "",
              key: "totalwagesSo110",
            },
            {
              label: "单位参加职工基本医疗保险缴费基数",
              value: "",
              key: "totalwagesSo310",
            },
            {
              label: "单位参加工伤保险缴费基数",
              value: "",
              key: "totalwagesSo410",
            },
            {
              label: "单位参加失业保险缴费基数",
              value: "",
              key: "totalwagesSo210",
            },
            {
              label: "单位参加生育保险缴费基数",
              value: "",
              key: "totalwagesSo510",
            },
          ],
        },
        {
          label: "本期实际缴纳基数",
          value: "",
          key: "",
          span: 24,
          type: "list",
          list: [
            {
              label: "参加城镇职工基本养老保险本期实际缴费金额",
              value: "",
              key: "totalpaymentSo110",
            },
            {
              label: "参加职工基本医疗保险本期实际缴费金额",
              value: "",
              key: "totalpaymentSo310",
            },
            {
              label: "参加工伤保险本期实际缴费金额",
              value: "",
              key: "totalpaymentSo410",
            },
            {
              label: "参加失业保险本期实际缴费金额",
              value: "",
              key: "totalpaymentSo210",
            },
            {
              label: "参加生育保险本期实际缴费金额",
              value: "",
              key: "totalpaymentSo510",
            },
          ],
        },
        {
          label: "单位累计欠缴金额",
          value: "",
          key: "",
          span: 24,
          type: "list",
          list: [
            {
              label: "单位参加城镇职工基本养老保险累计欠缴金额",
              value: "",
              key: "unpaidsocialinsSo110",
            },
            {
              label: "单位参加职工基本医疗保险累计欠缴金额",
              value: "",
              key: "unpaidsocialinsSo310",
            },
            {
              label: "参加工伤保险累计欠缴金额",
              value: "",
              key: "unpaidsocialinsSo410",
            },
            {
              label: "单位参加失业保险累计欠缴金额",
              value: "",
              key: "unpaidsocialinsSo210",
            },
            {
              label: "单位参加生育保险累计欠缴金额",
              value: "",
              key: "unpaidsocialinsSo510",
            },
          ],
        },
      ];
      break;
    case "基础信息":
      data = [
        {
          label: "专利名称",
          value: "",
          key: "patentName",
          span: 12,
          type: "text",
        },
        {
          label: "专利类型",
          value: "",
          key: "patentCategory",
          span: 12,
          type: "text",
        },

        {
          label: "申请号",
          value: "",
          key: "licenseCode",
          span: 12,
          type: "text",
        },
        {
          label: "申请日期",
          value: "",
          key: "requestDate",
          span: 12,
          type: "text",
        },

        {
          label: "公布/公告号",
          value: "",
          key: "outhorNum",
          span: 12,
          type: "text",
        },
        {
          label: "公布/公告日期",
          value: "",
          key: "pubTime",
          span: 12,
          type: "text",
        },
        {
          label: "分类号",
          value: "",
          key: "mainCategoryCode",
          span: 24,
          type: "text",
        },
        {
          label: "摘要",
          value: "",
          key: "summary",
          span: 24,
          type: "text",
        },
      ];
      break;
    case "申请人信息":
      data = [
        {
          label: "申请(专利权)人",
          value: "",
          key: "patentName",
          span: 12,
          type: "text",
        },
        {
          label: "发明人",
          value: "",
          key: "inventor",
          span: 12,
          type: "text",
        },
        {
          label: "申请人住址",
          value: "",
          key: "domicile",
          span: 24,
          type: "text",
        },
      ];
      break;
    case "代理人信息":
      data = [
        {
          label: "专利代理机构",
          value: "",
          key: "agentUnit",
          span: 12,
          type: "text",
        },
        {
          label: "专利代理师",
          value: "",
          key: "agentPerson",
          span: 12,
          type: "text",
        },
      ];
      break;
    case "法律状态":
      data = [
        {
          label: "最新法律状态",
          value: "",
          key: "stateMeaning",
          span: 12,
          type: "text",
        },
        {
          label: "法律状态公告日",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
      ];
      break;
    case "商标详情":
      data = [
        {
          label: "商标图案",
          value: "",
          key: "logoUrl",
          span: 24,
          type: "img",
        },
        {
          label: "商标名称",
          value: "",
          key: "name",
          span: 12,
          type: "text",
        },
        {
          label: "商标状态",
          value: "",
          key: "status",
          span: 12,
          type: "text",
        },
        {
          label: "商标类别",
          value: "",
          key: "types",
          span: 12,
          type: "text",
        },
        {
          label: "专用权期限",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "申请日期",
          value: "",
          key: "requestDate",
          span: 12,
          type: "text",
        },
        {
          label: "注册号",
          value: "",
          key: "number",
          span: 12,
          type: "text",
        },
        {
          label: "初审公告日期",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "注册公告日期",
          value: "",
          key: "registerdate",
          span: 12,
          type: "text",
        },
        {
          label: "申请人名称",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "代理机构",
          value: "",
          key: "agency",
          span: 12,
          type: "text",
        },
      ];
      break;
    case "标准信息详情":
      data = [
        {
          label: "标准名称",
          value: "",
          key: "name",
          span: 12,
          type: "text",
        },
        {
          label: "状态",
          value: "",
          key: "state",
          span: 12,
          type: "text",
        },
        {
          label: "标准编号",
          value: "",
          key: "standardNo",
          span: 12,
          type: "text",
        },
        {
          label: "标准级别",
          value: "",
          key: "standardCategory",
          span: 12,
          type: "text",
        },
        {
          label: "发布/批准日期",
          value: "",
          key: "establishedAt",
          span: 12,
          type: "text",
        },
        {
          label: "实施日期",
          value: "",
          key: "executedFrom",
          span: 12,
          type: "text",
        },
        {
          label: "中国标准分类号",
          value: "",
          key: "ccs",
          span: 12,
          type: "text",
        },
        {
          label: "国家标准分类号",
          value: "",
          key: "ics",
          span: 12,
          type: "text",
        },
        {
          label: "标准分类",
          value: "",
          key: "standardType",
          span: 12,
          type: "text",
        },
        {
          label: "行业",
          value: "",
          key: "industry",
          span: 12,
          type: "text",
        },
        {
          label: "归口单位",
          value: "",
          key: "caUnit",
          span: 12,
          type: "text",
        },
        {
          label: "主管部门",
          value: "",
          key: "",
          span: 12,
          type: "text",
        },
        {
          label: "起草单位",
          value: "",
          key: "draftUnits",
          span: 12,
          type: "link_list",
        },
        {
          label: "起草人",
          value: "",
          key: "drafters",
          span: 12,
          type: "text",
        },
      ];
      break;
    case "历史工商信息":
      data = [
        {
          label: "历史公司名称",
          value: "",
          key: "entName",
          span: 24,
          type: "list",
          list: [],
        },
        {
          label: "历史企业类型",
          value: "",
          key: "entType",
          span: 24,
          type: "list",
          list: [],
        },
        {
          label: "历史企业状态",
          value: "",
          key: "entStatus",
          span: 24,
          type: "list",
          list: [],
        },
        {
          label: "历史法定代表人",
          value: "",
          key: "",
          span: 24,
          type: "list",
          list: [],
        },
        {
          label: "历史注册资本",
          value: "",
          key: "regCap",
          span: 24,
          type: "list",
          list: [],
        },
        {
          label: "历史地址",
          value: "",
          key: "address",
          span: 24,
          type: "list",
          list: [],
        },
        {
          label: "历史经营范围",
          value: "",
          key: "operateScope",
          span: 24,
          type: "list",
          list: [],
        },
      ];
      break;
    case "招聘概况":
      data = [
        {
          label: "招聘渠道",
          value: "",
          key: "src",
          span: 12,
          type: "text",
        },
        {
          label: "岗位平均更新频率",
          value: "",
          key: "titleModifyDate",
          span: 12,
          type: "text",
        },
        {
          label: "岗位业务关键词",
          value: "",
          key: "titleKw",
          span: 12,
          type: "text",
        },
        {
          label: "岗位职级关键词",
          value: "",
          key: "titleLevel",
          span: 12,
          type: "text",
        },
        {
          label: "近三个月招聘岗位总数",
          value: "",
          key: "titleCnt",
          span: 12,
          type: "text",
        },
        {
          label: "主要招聘城市",
          value: "",
          key: "city",
          span: 12,
          type: "text",
        },
        {
          label: "招聘类型",
          value: "",
          key: "titleType",
          span: 12,
          type: "text",
        },
        {
          label: "平均薪资",
          value: "",
          key: "avgSal",
          span: 12,
          type: "text",
        },
      ];
      break;
    default:
      break;
  }
  return data;
}

// 获取客户下的所有收款单号
export function getVoucherNoForInvoice(data) {
  return [
    {
      title: "",
      type: "buttonList",
      value: [
        {
          type: "primary",
          plain: true,
          text: "绑定发票",
          active: "bind_invoice",
        },
      ],
    },
    {
      title: "",
      type: "table",
      select: true,
      value: "",
      data: data || [],
      height: "500px",
      props: [
        {
          prop: "voucherNo",
          label: "收款单号",
          width: "180",
          type: "text",
        },
        {
          prop: "contractNumber",
          label: "合同编号",
          width: "140",
          type: "text",
        },
        {
          prop: "money",
          label: "收款金额",
          width: "90",
          type: "text",
        },
        {
          prop: "auditedIncome",
          label: "已收款",
          width: "90",
          type: "text",
        },
        {
          prop: "accruedAssets",
          label: "未收款",
          width: "90",
          type: "text",
        },
        {
          prop: "addTime",
          label: "收款时间",
          with: "160",
          type: "text",
        },
        {
          prop: "status",
          label: "收款状态",
          width: "80",
          type: "text",
        },
        {
          prop: "payee",
          label: "收款人",
          width: "100",
          type: "text",
        },
        {
          prop: "invoiceNumber",
          label: "关联发票号码",
          width: "120",
          type: "text",
        },
        {
          prop: "isInvoicedText",
          label: "是否开票",
          width: "80",
          type: "text",
        },
      ],
    },
  ];
}

export function getQualification(type) {
  let data = [];
  switch (type) {
    // 行政许可
    case "administrativeLicensing":
      data = [
        {
          title: "行政许可编号",
          type: "input",
          key: "licno",
          value: "",
        },
        {
          title: "许可文件名称",
          type: "input",
          key: "licname",
          value: "",
        },
        {
          title: "有效期自",
          type: "time_date",
          key: "valform",
          value: "",
        },
        {
          title: "有效期至",
          type: "time_date",
          key: "valto",
          value: "",
        },
        {
          title: "许可机关",
          type: "input",
          key: "licanth",
          value: "",
        },
        {
          title: "许可内容",
          type: "input",
          key: "licensecontent",
          value: "",
        },
      ];
      break;
    // 资质证书
    case "qualificationInformation":
      data = [
        {
          title: "证书名称",
          type: "input",
          key: "licname",
          value: "",
        },
        {
          title: "证书编号",
          type: "input",
          key: "licno",
          value: "",
        },
        {
          title: "有效期自",
          type: "time_date",
          key: "valform",
          value: "",
        },
        {
          title: "截止日期",
          type: "time_date",
          key: "valto",
          value: "",
        },
        {
          title: "证书状态",
          type: "select",
          key: "licnameStatus",
          value: "",
          options: [
            {
              label: "有效",
              value: "有效",
            },
            {
              label: "注销",
              value: "注销",
            },
            {
              label: "未知",
              value: "未知",
            },
            {
              label: "撤销",
              value: "撤销",
            },
            {
              label: "无效",
              value: "无效",
            },
            {
              label: "吊销",
              value: "吊销",
            },
            {
              label: "暂停",
              value: "暂停",
            },
          ],
        },
        {
          title: "证书类型",
          type: "select",
          key: "licnameKind",
          value: "",
          options: [
            {
              label: "建筑资质",
              value: "建筑资质",
            },
            {
              label: "其他",
              value: "其他",
            },
            {
              label: "金融许可证",
              value: "金融许可证",
            },
            {
              label: "药品生产许可证",
              value: "药品生产许可证",
            },
            {
              label: "电信增值业务经营许可证",
              value: "电信增值业务经营许可证",
            },
            {
              label: "商业特许经营许可证",
              value: "商业特许经营许可证",
            },
            {
              label: "软件产品证书",
              value: "软件产品证书",
            },
            {
              label: "高新技术企业",
              value: "高新技术企业",
            },
            {
              label: "排污许可证",
              value: "排污许可证",
            },
            {
              label: "医疗器械生产许可证",
              value: "医疗器械生产许可证",
            },
            {
              label: "办学许可证",
              value: "办学许可证",
            },
            {
              label: "安全生产许可证",
              value: "安全生产许可证",
            },
            {
              label: "食品安全许可证",
              value: "食品安全许可证",
            },
          ],
        },
      ];
      break;
    // 建筑资质
    case "architectureQualification":
      data = [
        {
          title: "资质类别",
          type: "select",
          key: "type",
          value: "",
          options: [
            {
              label: "招标代理资质证书",
              value: "招标代理资质证书",
            },
            {
              label: "承装（修、试）电力设施许可证",
              value: "承装（修、试）电力设施许可证",
            },
            {
              label: "设计资质",
              value: "设计资质",
            },
            {
              label: "工程设计资质证书",
              value: "工程设计资质证书",
            },
            {
              label: "电力业务许可证",
              value: "电力业务许可证",
            },
            {
              label: "建筑施工资质证书",
              value: "建筑施工资质证书",
            },
            {
              label: "造价咨询资质",
              value: "造价咨询资质",
            },
            {
              label: "城市规划编制单位资质认定",
              value: "城市规划编制单位资质认定",
            },
            {
              label: "甲级工程造价咨询单位",
              value: "甲级工程造价咨询单位",
            },
            {
              label: "监理资质",
              value: "监理资质",
            },
            {
              label: "安全生产许可证",
              value: "安全生产许可证",
            },
            {
              label: "建筑业企业资质",
              value: "建筑业企业资质",
            },
            {
              label: "建筑业资质证书",
              value: "建筑业资质证书",
            },
            {
              label: "勘察资质",
              value: "勘察资质",
            },
            {
              label: "工程勘察资质证书",
              value: "工程勘察资质证书",
            },
            {
              label: "工程监理资质证书",
              value: "工程监理资质证书",
            },
            {
              label: "设计施工一体化资质证书",
              value: "设计施工一体化资质证书",
            },
            {
              label: "安全生产许可",
              value: "安全生产许可",
            },
          ],
        },
        {
          title: "资质证书号",
          type: "input",
          key: "registerNo",
          value: "",
        },
        {
          title: "资质名称及等级",
          type: "input",
          key: "name",
          value: "",
        },
        {
          title: "发证日期",
          type: "time_date",
          key: "validStart",
          value: "",
        },
        {
          title: "证书有效期",
          type: "time_date",
          key: "validEnd",
          value: "",
        },
        {
          title: "发证机关",
          type: "input",
          key: "issueOrg",
          value: "",
        },
        {
          title: "资质范围",
          type: "input",
          key: "scope",
          value: "",
        },
      ];
      break;
    // 专利信息
    case "patentInfo":
      data = [
        {
          title: "专利名称",
          type: "input",
          key: "patentName",
          value: "",
          options: [],
        },
        {
          title: "专利类型",
          type: "input",
          key: "patentCategory",
          value: "",
        },
        {
          title: "公告/公布号",
          type: "input",
          key: "outhorNum",
          value: "",
        },
        {
          title: "申请号",
          type: "input",
          key: "licenseCode",
          value: "",
        },
        {
          title: "申请日期",
          type: "time_date",
          key: "requestDate",
          value: "",
        },
        {
          title: "法律状态",
          type: "input",
          key: "stateMeaning",
          value: "",
        },
        {
          title: "资质范围",
          type: "input",
          key: "scope",
          value: "",
        },
      ];
      break;
    // 商标信息
    case "brandInfo":
      data = [
        {
          title: "商标",
          type: "input",
          key: "logoUrl",
          value: "",
          options: [],
        },
        {
          title: "商标名称",
          type: "input",
          key: "name",
          value: "",
        },
        {
          title: "申请日期",
          type: "time_date",
          key: "requestDate",
          value: "",
        },
        {
          title: "注册号",
          type: "input",
          key: "number",
          value: "",
        },
        // {
        //   title: "注册公告日期",
        //   type: "time_date",
        //   key: "validEnd",
        //   value: "",
        // },
        {
          title: "商标类别",
          type: "input",
          key: "type",
          value: "",
        },
        {
          title: "状态",
          type: "input",
          key: "status",
          value: "",
        },
      ];
      break;
    // 软件著作权
    case "softwareCopyrightInfo":
      data = [
        {
          title: "软件名称",
          type: "input",
          key: "crName",
          value: "",
        },
        {
          title: "软件简称",
          type: "input",
          key: "crShortname",
          value: "",
        },
        {
          title: "版本号",
          type: "time_date",
          key: "crBatchnum",
          value: "",
        },
        {
          title: "首次发表日期",
          type: "time_date",
          key: "crFirstdate",
          value: "",
        },
        {
          title: "登记号",
          type: "input",
          key: "crRegno",
          value: "",
        },
        {
          title: "登记日期",
          type: "time_date",
          key: "crRegdate",
          value: "",
        },
        {
          title: "软件著作分类",
          type: "input",
          key: "crSoftwaretype",
          value: "",
        },
        {
          title: "行业分类",
          type: "input",
          key: "crTypecode",
          value: "",
        },
      ];
      break;
    // 作品著作权
    case "workCopyrightInfo":
      data = [
        {
          title: "作品名称",
          type: "input",
          key: "wrName",
          value: "",
        },

        {
          title: "创作完成时间",
          type: "time_date",
          key: "wrCompletiondate",
          value: "",
        },
        {
          title: "首次发表日期",
          type: "time_date",
          key: "wrPublicationdate",
          value: "",
        },
        {
          title: "登记号",
          type: "input",
          key: "wrRegistrationno",
          value: "",
        },
        {
          title: "登记日期",
          type: "time_date",
          key: "wrRegistrationdate",
          value: "",
        },
        {
          title: "作品类别",
          type: "input",
          key: "wrType",
          value: "",
        },
      ];
      break;
    // ICP备案
    case "IPCInfo":
      data = [
        {
          title: "网址",
          type: "input",
          key: "openUrl",
          value: "",
        },
        {
          title: "域名",
          type: "input",
          key: "domain",
          value: "",
        },
        {
          title: "网站名称",
          type: "input",
          key: "name",
          value: "",
        },
        {
          title: "网站备案/许可证号",
          type: "input",
          key: "icp",
          value: "",
        },
        {
          title: "审核日期",
          type: "time_date",
          key: "auditDate",
          value: "",
        },
      ];
      break;
    // ICP备案
    case "standardInfo":
      data = [
        {
          title: "标准名称",
          type: "input",
          key: "name",
          value: "",
        },
        {
          title: "标准编号",
          type: "input",
          key: "standardNo",
          value: "",
        },
        {
          title: "标准级别",
          type: "input",
          key: "standardCategory",
          value: "",
        },
        {
          title: "起草单位",
          type: "input",
          key: "draftUnitsByTrans",
          value: "",
        },
        {
          title: "发布/批准日期",
          type: "time_date",
          key: "approvalDate",
          value: "",
        },
        {
          title: "实施日期",
          type: "time_date",
          key: "executedFrom",
          value: "",
        },
      ];
      break;
    default:
      break;
  }
  return data;
}
